import {useEffect} from 'react';

import helpers from '../utils/helpers';

export const useScrollTop = (deps = []) => {
    useEffect(() => {
        helpers.scrollTop();
    }, deps);
};

export default useScrollTop;
